import axios from 'axios';

const makeRequestAxios = async (method, url, body, headers = []) => {
  const loc = 'makeRequestAxios';
  let responseData;
  
  try {
    let config = {
      method,
      url,
      timeout: 30000,
      headers: headers,
      data: body,
      validateStatus: function (status) {
        return status === 200 || status == 400;
      }
    };

    const response = await axios(config);
    responseData = response?.data;    
  } catch (error) {
    let err;
    if (error.response) {
      console.error(loc, JSON.stringify(error.response));
      err = error.response;
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.error(loc, error.request);
      err = error.request;
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error(loc, error.message);
      err = error.message;
    }
    throw new Error(err);
  }

  return responseData;
};

export { makeRequestAxios };